'use client'

import React, { ElementRef, useEffect, useRef } from 'react'
import jazzicon from '@metamask/jazzicon'
import { bs58 } from '@coral-xyz/anchor/dist/cjs/utils/bytes'

type JazzIconProps = {
  diameter: number
  className?: string
  publicAddress: string
}

const JazzIcon = ({ diameter, className, publicAddress }: JazzIconProps) => {
  const ref = useRef<ElementRef<'div'>>(null)

  useEffect(() => {
    if (!publicAddress) return
    const decoded = bs58.decode(publicAddress)
    const hexVal = Buffer.from(decoded).toString('hex')

    const icon = jazzicon(diameter, parseInt(hexVal.slice(-8), 16))

    if (ref.current) {
      ref.current.innerHTML = ''
      ref.current.appendChild(icon)
    }
  }, [diameter, publicAddress])

  return <div className={className} ref={ref} />
}

export default JazzIcon
